import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyQuotesComponent } from './my-quotes.component';
import { MyQuotesService } from './my-quotes.service';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { EquipmentQuotesComponent } from './equipment-quotes/equipment-quotes.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { KngButtonModule, KngFilterPanelModule, KngCardListModule, KngStatusSelectorModule, AccordionModule } from 'kinetic-angular';
import { TruncateModule } from '../../pipes/truncate/truncate.module';
import { QuotePromoBannersComponent } from './quote-promo-banners/quote-promo-banners.component';
const route: Routes = [
	{ path: '', component: MyQuotesComponent, data: { title: 'MyQuotes' } }
];
@NgModule({
	imports: [RouterModule.forChild(route)],
	exports: [RouterModule]
})

export class MyQuotesRoutingModule {}

@NgModule({
	declarations: [ MyQuotesComponent, EquipmentQuotesComponent, QuotePromoBannersComponent ],
	imports: [ CommonModule, MyQuotesRoutingModule, KngButtonModule, KngFilterPanelModule, MatChipsModule,
		MatIconModule, MatFormFieldModule, KngCardListModule, KngStatusSelectorModule, FormsModule, AccordionModule, TruncateModule ],
	exports: [MyQuotesComponent],
	providers: [MyQuotesService]
})
export class MyQuotesModule {}
